module.exports = __webpack_public_path__ + "img/T4-B-xs_1.fd0cc857.png";